import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'designing-smart-page-edits',
  styleUrls: ['../designing.component.scss'],
  templateUrl: './smartPageEdits.component.html',
})
export class DesigningSmartPageEditsComponent {
  @Input() step;
  @Input() totalSteps;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  constructor(public translate: TranslateService) {}

  submit() {
    this.next.emit();
  }
}
